import React from "react";
import useSelect from "../hooks/useSelect";
import ResultComponent from "./ResultComponent";
import { CloseIcon, Container, Question, Wrapper } from "./styled";
import 김병조이미지 from "../assets/김병조-독립운동가.jpeg";
import styled from "styled-components";

interface Props {
  setScreen: React.Dispatch<React.SetStateAction<string>>;
}

const Stage6 = ({ setScreen }: Props) => {
  const ANSWER = 1; // 김병조 - 독립운동가
  const { select, onClickItem } = useSelect(ANSWER);

  return (
    <Container>
      <Question>
        이 인물은 독립운동가일까요
        <br />
        친일파일까요?
      </Question>

      <AnswerContainer>
        <Image src={김병조이미지} alt="김병조" />

        <Wrapper onClick={() => onClickItem(1)} $correct={!!select}>
          <Text>⓵ 독립운동가</Text>
          {select === 1 && <CloseIcon />}
        </Wrapper>
        <Wrapper onClick={() => onClickItem(2)} $incorrect={select === 2}>
          <Text>⓶ 친일파</Text>
          {select === 2 && <CloseIcon />}
        </Wrapper>
      </AnswerContainer>

      {!!select && (
        <ResultComponent
          select={select}
          answer={ANSWER}
          nextStage={7}
          setScreen={setScreen}
          desc={
            <Desc>
              <strong>김병조</strong>
              <br />
              김병조(金秉祚, 1877년 1월 10일 ~ 1952년)는 일제강점기의 목회자,
              독립운동가이며, 한국의 장로교 목사이다. 3·1 만세 운동 당시 민족
              대표 33인의 한사람이며, 6.25 전쟁 중 공산군의 손에 피살되었다.
              평안북도 출신으로, 아호는 일재(一齋).
            </Desc>
          }
        />
      )}
    </Container>
  );
};

export default Stage6;

const Image = styled.img`
  width: 280px;
`;

const AnswerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  flex-direction: column;

  margin-top: 20px;
`;

const Text = styled.div`
  font-size: 30px;
`;

const Desc = styled.div`
  font-size: 20px;

  & strong {
    font-size: 30px;
  }
`;
